import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';
import { provideMarkdown } from 'ngx-markdown';
import { CoreModule } from './app/core/core.module';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { provideAnimations } from '@angular/platform-browser/animations';
import { bootstrapApplication, BrowserModule, HammerModule } from '@angular/platform-browser';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { NgxsModule, Store } from '@ngxs/store';
import {
  ENV,
  HttpAuthInterceptorService,
  initLanguagesFactory,
  ProductErrorInterceptorService,
  RouterTrackerService,
  TranslocoModuleGame,
  TranslocoRootModule,
} from '@jump-tools-front/shared';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

if (environment.production) {
  enableProdMode();
}

//Methode pour les assets Icomoon (on passe par un proxy back et on concatene l'origine au path dans index.html
function replaceAssetUrls(): () => void {
  return (): void => {
    const links = document.querySelectorAll<HTMLLinkElement>('link[href*="/api/asset"]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href) {
        return;
      }

      const updatedHref = window.location.origin + href + '?platform=learniz';
      link.setAttribute('href', updatedHref);
    });
  };
}

function initializeApp(routerTrackerService: RouterTrackerService) {
  return (): void => {
    if (environment.production) {
      routerTrackerService.init('learniz');
    }
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      NgxsModule.forRoot([], { developmentMode: !environment.production }),
      NgxsRouterPluginModule.forRoot(),
      NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
      CoreModule,
      MatSnackBarModule,
      HammerModule,
      TranslocoRootModule.forRoot(environment),
      TranslocoModuleGame.forRoot(environment),
    ),
    provideMarkdown(),
    { provide: HTTP_INTERCEPTORS, useClass: ProductErrorInterceptorService, multi: true },
    // order of interceptor is really important: if A and B are interceptor then we will have :
    // req A -> req B -> call HTTP -> res B -> res A
    // here auth need to catch error code first to handle 401 then other interceptor can manage other error codes
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptorService, multi: true },
    // by default take the browser local language
    provideAppInitializer(() => {
      const initializerFn = initLanguagesFactory(inject(Store));
      return initializerFn();
    }),
    { provide: ENV, useValue: environment },
    { provide: MatDialogRef, useValue: {} },
    RouterTrackerService,
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(RouterTrackerService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const replaceAssetUrlsFn = replaceAssetUrls();
      return replaceAssetUrlsFn();
    }),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch(err => console.error(err));
